export default __webpack_public_path__ + "static/media/website.2333f5a6.svg";